// src/reports/ReportsViewToggle.jsx
import React, { useState } from 'react';
import {
  Box,
  ToggleButton,
  ToggleButtonGroup,
  Typography,
  Paper,
} from '@mui/material';
import { FaList, FaTh } from 'react-icons/fa';
import ReportsGridPreview from './ReportsGridPreview';
import ReportsListView from './ReportsListView';

export default function ReportsViewToggle({ reports = [], loading = false }) {
  const [viewMode, setViewMode] = useState('list');

  const handleViewChange = (event, newView) => {
    if (newView !== null) {
      setViewMode(newView);
    }
  };

  return (
    <Box>
      {/* View Toggle Header */}
      <Paper
        elevation={1}
        sx={{
          p: 2,
          mb: 3,
          borderRadius: '12px',
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          bgcolor: '#f5faf6',
        }}
      >
        <Typography variant="body2" color="text.secondary">
          {reports.length} reports available
        </Typography>
        <ToggleButtonGroup
          value={viewMode}
          exclusive
          onChange={handleViewChange}
          aria-label="view mode"
          size="small"
          sx={{
            '& .MuiToggleButton-root': {
              '&.Mui-selected': {
                bgcolor: '#2e7d32',
                color: '#fff',
                '&:hover': {
                  bgcolor: '#1b5e20',
                },
              },
            },
          }}
        >
          <ToggleButton value="list" aria-label="list view">
            <FaList size={16} style={{ marginRight: 4 }} />
            List
          </ToggleButton>
          <ToggleButton value="grid" aria-label="grid view">
            <FaTh size={16} style={{ marginRight: 4 }} />
            Grid
          </ToggleButton>
        </ToggleButtonGroup>
      </Paper>

      {/* Render selected view */}
      {viewMode === 'list' ? (
        <ReportsListView reports={reports} loading={loading} />
      ) : (
        <ReportsGridPreview reports={reports} />
      )}
    </Box>
  );
}